export default __webpack_public_path__ + "static/media/logo_governanca.06a6c49f.png";